import { LabelTheme } from '@kite-js/theme-types';

const label: LabelTheme = {
    textWeight: 'Normal',
};

export default label;
